module.exports = __webpack_public_path__ + "static/media/arrow.faa4ffed.svg";